(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['wysiwyg.viewer.skins.CalendarDefaultSkin'] = {
  "react": [
    [
      "div",
      "container",
      [
        "_date-picker"
      ],
      {},
      [
        "div",
        "header",
        [
          "_header"
        ],
        {},
        [
          "button",
          "previousYearNav",
          [
            "_year-navigation",
            "_year-navigation-previous"
          ],
          {},
          [
            "svg",
            null,
            [
              "_nav-symbol"
            ],
            {
              "viewBox": "0 0 14.1 12.6"
            },
            [
              "path",
              null,
              [],
              {
                "d": "M14 .9l-.7-.8L7 6.6l6.3 6.2.7-.7-5.6-5.5L14 .9zM7 .9L6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
              }
            ]
          ]
        ],
        [
          "button",
          "previousMonthNav",
          [
            "_month-navigation",
            "_month-navigation-previous"
          ],
          {},
          [
            "svg",
            null,
            [
              "_nav-symbol"
            ],
            {
              "viewBox": "0 0 7 12.6"
            },
            [
              "path",
              null,
              [],
              {
                "d": "M7 .9L6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
              }
            ]
          ]
        ],
        [
          "div",
          "currentMonthWithYear",
          [
            "_current-month-with-year"
          ],
          {}
        ],
        [
          "button",
          "nextMonthNav",
          [
            "_month-navigation",
            "_month-navigation-next"
          ],
          {},
          [
            "svg",
            null,
            [
              "_nav-symbol"
            ],
            {
              "viewBox": "0 0 7 12.6"
            },
            [
              "path",
              null,
              [],
              {
                "d": "M7 .9L6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
              }
            ]
          ]
        ],
        [
          "button",
          "nextYearNav",
          [
            "_year-navigation",
            "_year-navigation-next"
          ],
          {},
          [
            "svg",
            null,
            [
              "_nav-symbol"
            ],
            {
              "viewBox": "0 0 14.1 12.6"
            },
            [
              "path",
              null,
              [],
              {
                "d": "M14 .9l-.7-.8L7 6.6l6.3 6.2.7-.7-5.6-5.5L14 .9zM7 .9L6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
              }
            ]
          ]
        ]
      ],
      [
        "table",
        null,
        [],
        {},
        [
          "thead",
          null,
          [],
          {},
          [
            "tr",
            "dayNames",
            [
              "_day-names"
            ],
            {
              "role": "row"
            }
          ]
        ],
        [
          "tbody",
          "month",
          [],
          {}
        ]
      ],
      [
        "div",
        "yearOptionsWrapper",
        [
          "_year-options-wrapper"
        ],
        {}
      ]
    ]
  ],
  "exports": {
    "month": {
      "skin": "wysiwyg.viewer.skins.MonthDefaultSkin"
    }
  },
  "params": {
    "shd-calendar": "BOX_SHADOW",
    "rd-calendar": "BORDER_RADIUS",
    "bg-calendar": "BG_COLOR_ALPHA",
    "brw-calendar": "BORDER_BOTTOM_SIZE",
    "brd-calendar": "BORDER_COLOR",
    "fnt-family-day": "FONT_FAMILY",
    "txt-size-day": "TEXT_SIZE",
    "txt-day": "TEXT_COLOR",
    "bg-day-selected": "COLOR",
    "txt-day-selected": "TEXT_COLOR",
    "rd-day-selected": "BORDER_RADIUS",
    "fnt-family-header": "FONT_FAMILY",
    "txt-header": "TEXT_COLOR",
    "txt-size-header": "TEXT_SIZE",
    "bg-header": "BG_COLOR_ALPHA"
  },
  "paramsDefaults": {
    "shd-calendar": "0 0 0 rgba(0, 0, 0, 0)",
    "rd-calendar": "10px",
    "bg-calendar": "#ffffff",
    "brw-calendar": "1px",
    "brd-calendar": "#aeaeae",
    "fnt-family-day": "arial",
    "txt-size-day": "14px",
    "txt-day": "#000000",
    "bg-day-selected": "#7343d1",
    "txt-day-selected": "#ffffff",
    "rd-day-selected": "0",
    "fnt-family-header": "arial",
    "txt-header": "#ffffff",
    "txt-size-header": "18px",
    "bg-header": "#7343d1"
  },
  "css": {
    "%": "width:320px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;",
    "%[data-state~=\"mobile\"]": "height:100%;width:300px;margin:auto 10px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;",
    "%[data-state~=\"mobile\"]:before": "content:\"\";cursor:pointer;margin-bottom:8px;background:url(\"//static.parastorage.com/services/santa-resources/resources/viewer/datePicker/mobile_x_button.svg\") no-repeat center;background-size:17px 17px;width:40px;height:40px;",
    "% > %_date-picker": "[shd-calendar]    [rd-calendar]    background-color:[bg-calendar];border:[brw-calendar] solid [brd-calendar];overflow:hidden;display:inline-block;position:relative;width:100%;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:47;",
    "%_rtl-direction > %_date-picker > %_header": "-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;flex-direction:row-reverse;",
    "%_rtl-direction > %_date-picker > %_header %_month-navigation-next > %_nav-symbol,%_rtl-direction > %_date-picker > %_header %_year-navigation-next > %_nav-symbol": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "%_rtl-direction > %_date-picker > %_header %_year-navigation-previous > %_nav-symbol,%_rtl-direction > %_date-picker > %_header %_month-navigation-previous > %_nav-symbol": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "% > %_date-picker %_day-names": "padding:0 20px;margin-top:15px;display:block;",
    "% > %_date-picker %_day-names:empty": "display:none;",
    "%[data-state~=\"mobile\"] > %_date-picker %_day-names": "padding:0 10px;",
    "% > %_date-picker %_day-names %_day-name": "width:40px;height:40px;[fnt-family-day]        font-size:[txt-size-day];display:inline-block;line-height:40px;text-align:center;font-weight:bold;color:[txt-day];",
    "%[data-state~=\"mobile\"] > %_date-picker %_day-names %_day-name": "font-size:14px;",
    "% > %_date-picker %_day-names %_day-name %_sr-only": "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0;",
    "% > %_date-picker > %_year-options-wrapper": "position:relative;text-align:center;max-height:280px;overflow-y:auto;margin-top:15px;margin-bottom:20px;",
    "% > %_date-picker > %_year-options-wrapper:empty": "display:none;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list": "display:inline-block;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item": "width:80px;height:40px;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item": "width:130px;",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item:not(%_selected):hover > %_year-content:before": "background-color:[bg-day-selected];opacity:0.15;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item%_selected > %_year-content": "color:[txt-day-selected];",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item%_selected > %_year-content:before": "background-color:[bg-day-selected];",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item > %_year-content": "width:78px;height:34px;[fnt-family-day]            font-size:[txt-size-day];color:[txt-day];display:block;line-height:34px;margin:3px 1px;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item > %_year-content": "font-size:14px;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item > %_year-content:before": "[rd-day-selected]              width:78px;height:34px;position:absolute;top:auto;right:auto;bottom:auto;left:auto;content:\"\";display:block;z-index:-1;",
    "%[data-is-responsive=true]": "margin-top:22px;",
    "% > %_date-picker > %_header": "[fnt-family-header]  width:100%;height:60px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;word-wrap:break-word;color:[txt-header];font-size:[txt-size-header];background-color:[bg-header];border-bottom:[brw-calendar] solid [brd-calendar];",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header": "font-size:16px;",
    "% > %_date-picker > %_header > %_year-navigation,% > %_date-picker > %_header > %_month-navigation": "position:relative;display:-webkit-inline-box;display:-webkit-inline-flex;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;text-align:center;cursor:pointer;",
    "% > %_date-picker > %_header > %_year-navigation > %_nav-symbol,% > %_date-picker > %_header > %_month-navigation > %_nav-symbol": "height:13px;pointer-events:none;fill:[txt-header];",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header > %_year-navigation > %_nav-symbol,%[data-state~=\"mobile\"] > %_date-picker > %_header > %_month-navigation > %_nav-symbol": "height:17px;",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_header > %_year-navigation:hover > %_nav-symbol,%[data-state~=\"notMobile\"] > %_date-picker > %_header > %_month-navigation:hover > %_nav-symbol": "fill-opacity:0.75;",
    "% > %_date-picker > %_header > %_year-navigation": "width:25px;height:25px;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header > %_year-navigation": "width:40px;height:40px;",
    "% > %_date-picker > %_header > %_month-navigation": "width:20px;height:25px;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header > %_month-navigation": "width:40px;height:40px;",
    "% > %_date-picker > %_header > %_month-navigation-next,% > %_date-picker > %_header > %_year-navigation-next": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_header > %_month-navigation-previous": "margin-left:5px;",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_header > %_month-navigation-next": "margin-right:5px;",
    "% > %_date-picker > %_header > %_current-month-with-year": "width:170px;text-align:center;display:inline-block;color:[txt-header];cursor:pointer;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header > %_current-month-with-year": "width:120px;",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_header > %_current-month-with-year:hover": "opacity:0.75;"
  }
}
 skins['wysiwyg.viewer.skins.CalendarTextBetweenNavSkin'] = {
  "react": [
    [
      "div",
      "container",
      [
        "_date-picker"
      ],
      {},
      [
        "div",
        "header",
        [
          "_header"
        ],
        {},
        [
          "div",
          null,
          [
            "_month-wrapper"
          ],
          {},
          [
            "button",
            "previousMonthNav",
            [
              "_month-navigation",
              "_month-navigation-previous"
            ],
            {},
            [
              "svg",
              null,
              [
                "_nav-symbol"
              ],
              {
                "viewBox": "0 0 7 12.6"
              },
              [
                "path",
                null,
                [],
                {
                  "d": "M7 .9L6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
                }
              ]
            ]
          ],
          [
            "div",
            "currentMonth",
            [
              "_current-month"
            ],
            {}
          ],
          [
            "button",
            "nextMonthNav",
            [
              "_month-navigation",
              "_month-navigation-next"
            ],
            {},
            [
              "svg",
              null,
              [
                "_nav-symbol"
              ],
              {
                "viewBox": "0 0 7 12.6"
              },
              [
                "path",
                null,
                [],
                {
                  "d": "M7 .9L6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
                }
              ]
            ]
          ]
        ],
        [
          "div",
          null,
          [
            "_year-wrapper"
          ],
          {},
          [
            "button",
            "previousYearNav",
            [
              "_year-navigation",
              "_year-navigation-previous"
            ],
            {},
            [
              "svg",
              null,
              [
                "_nav-symbol"
              ],
              {
                "viewBox": "0 0 7 12.6"
              },
              [
                "path",
                null,
                [],
                {
                  "d": "M7 .9L6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
                }
              ]
            ]
          ],
          [
            "div",
            "currentYear",
            [
              "_current-year"
            ],
            {}
          ],
          [
            "button",
            "nextYearNav",
            [
              "_year-navigation",
              "_year-navigation-next"
            ],
            {},
            [
              "svg",
              null,
              [
                "_nav-symbol"
              ],
              {
                "viewBox": "0 0 7 12.6"
              },
              [
                "path",
                null,
                [],
                {
                  "d": "M7 .9L6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
                }
              ]
            ]
          ]
        ]
      ],
      [
        "table",
        null,
        [],
        {},
        [
          "thead",
          null,
          [],
          {},
          [
            "tr",
            "dayNames",
            [
              "_day-names"
            ],
            {
              "role": "row"
            }
          ]
        ],
        [
          "tbody",
          "month",
          [],
          {}
        ]
      ],
      [
        "div",
        "yearOptionsWrapper",
        [
          "_year-options-wrapper"
        ],
        {}
      ]
    ]
  ],
  "exports": {
    "month": {
      "skin": "wysiwyg.viewer.skins.MonthDefaultSkin"
    }
  },
  "params": {
    "shd-calendar": "BOX_SHADOW",
    "rd-calendar": "BORDER_RADIUS",
    "bg-calendar": "BG_COLOR_ALPHA",
    "brw-calendar": "BORDER_BOTTOM_SIZE",
    "brd-calendar": "BORDER_COLOR",
    "fnt-family-day": "FONT_FAMILY",
    "txt-size-day": "TEXT_SIZE",
    "txt-day": "TEXT_COLOR",
    "bg-day-selected": "COLOR",
    "txt-day-selected": "TEXT_COLOR",
    "rd-day-selected": "BORDER_RADIUS",
    "fnt-family-header": "FONT_FAMILY",
    "txt-header": "TEXT_COLOR",
    "txt-size-header": "TEXT_SIZE",
    "bg-header": "BG_COLOR_ALPHA"
  },
  "paramsDefaults": {
    "shd-calendar": "0 0 0 rgba(0, 0, 0, 0)",
    "rd-calendar": "10px",
    "bg-calendar": "#ffffff",
    "brw-calendar": "1px",
    "brd-calendar": "#aeaeae",
    "fnt-family-day": "arial",
    "txt-size-day": "14px",
    "txt-day": "#000000",
    "bg-day-selected": "#7343d1",
    "txt-day-selected": "#ffffff",
    "rd-day-selected": "0",
    "fnt-family-header": "arial",
    "txt-header": "#ffffff",
    "txt-size-header": "18px",
    "bg-header": "#7343d1"
  },
  "css": {
    "%": "width:320px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;",
    "%[data-state~=\"mobile\"]": "height:100%;width:300px;margin:auto 10px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;",
    "%[data-state~=\"mobile\"]:before": "content:\"\";cursor:pointer;margin-bottom:8px;background:url(\"//static.parastorage.com/services/santa-resources/resources/viewer/datePicker/mobile_x_button.svg\") no-repeat center;background-size:17px 17px;width:40px;height:40px;",
    "% > %_date-picker": "[shd-calendar]    [rd-calendar]    background-color:[bg-calendar];border:[brw-calendar] solid [brd-calendar];overflow:hidden;display:inline-block;position:relative;width:100%;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:47;",
    "%_rtl-direction > %_date-picker > %_header": "-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;flex-direction:row-reverse;",
    "%_rtl-direction > %_date-picker > %_header %_month-navigation-next > %_nav-symbol,%_rtl-direction > %_date-picker > %_header %_year-navigation-next > %_nav-symbol": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "%_rtl-direction > %_date-picker > %_header %_year-navigation-previous > %_nav-symbol,%_rtl-direction > %_date-picker > %_header %_month-navigation-previous > %_nav-symbol": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "% > %_date-picker %_day-names": "padding:0 20px;margin-top:15px;display:block;",
    "% > %_date-picker %_day-names:empty": "display:none;",
    "%[data-state~=\"mobile\"] > %_date-picker %_day-names": "padding:0 10px;",
    "% > %_date-picker %_day-names %_day-name": "width:40px;height:40px;[fnt-family-day]        font-size:[txt-size-day];display:inline-block;line-height:40px;text-align:center;font-weight:bold;color:[txt-day];",
    "%[data-state~=\"mobile\"] > %_date-picker %_day-names %_day-name": "font-size:14px;",
    "% > %_date-picker %_day-names %_day-name %_sr-only": "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0;",
    "% > %_date-picker > %_year-options-wrapper": "position:relative;text-align:center;max-height:280px;overflow-y:auto;margin-top:15px;margin-bottom:20px;",
    "% > %_date-picker > %_year-options-wrapper:empty": "display:none;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list": "display:inline-block;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item": "width:80px;height:40px;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item": "width:130px;",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item:not(%_selected):hover > %_year-content:before": "background-color:[bg-day-selected];opacity:0.15;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item%_selected > %_year-content": "color:[txt-day-selected];",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item%_selected > %_year-content:before": "background-color:[bg-day-selected];",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item > %_year-content": "width:78px;height:34px;[fnt-family-day]            font-size:[txt-size-day];color:[txt-day];display:block;line-height:34px;margin:3px 1px;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item > %_year-content": "font-size:14px;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item > %_year-content:before": "[rd-day-selected]              width:78px;height:34px;position:absolute;top:auto;right:auto;bottom:auto;left:auto;content:\"\";display:block;z-index:-1;",
    "%[data-is-responsive=true]": "margin-top:22px;",
    "% > %_date-picker > %_header": "[fnt-family-header]  width:100%;height:60px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;color:[txt-header];word-wrap:break-word;font-size:[txt-size-header];background-color:[bg-header];border-bottom:[brw-calendar] solid [brd-calendar];",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header": "font-size:16px;",
    "% > %_date-picker > %_header %_month-wrapper": "display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;",
    "%_rtl-direction > %_date-picker > %_header %_month-wrapper": "-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;flex-direction:row-reverse;",
    "% > %_date-picker > %_header %_year-wrapper": "display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;",
    "%_rtl-direction > %_date-picker > %_header %_year-wrapper": "-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;flex-direction:row-reverse;",
    "% > %_date-picker > %_header %_year-navigation,% > %_date-picker > %_header %_month-navigation": "width:20px;height:25px;position:relative;display:-webkit-inline-box;display:-webkit-inline-flex;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;text-align:center;cursor:pointer;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header %_year-navigation,%[data-state~=\"mobile\"] > %_date-picker > %_header %_month-navigation": "width:40px;height:40px;",
    "% > %_date-picker > %_header %_year-navigation > %_nav-symbol,% > %_date-picker > %_header %_month-navigation > %_nav-symbol": "height:13px;pointer-events:none;fill:[txt-header];",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header %_year-navigation > %_nav-symbol,%[data-state~=\"mobile\"] > %_date-picker > %_header %_month-navigation > %_nav-symbol": "height:17px;",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_header %_year-navigation:hover > %_nav-symbol,%[data-state~=\"notMobile\"] > %_date-picker > %_header %_month-navigation:hover > %_nav-symbol": "fill-opacity:0.75;",
    "% > %_date-picker > %_header %_month-navigation-next,% > %_date-picker > %_header %_year-navigation-next": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header %_year-navigation-next": "margin-left:-10px;",
    "%_rtl-direction[data-state~=\"mobile\"] > %_date-picker > %_header %_year-navigation-next": "margin-right:-10px;margin-left:0px;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header %_year-navigation-previous": "margin-right:-6px;",
    "%_rtl-direction[data-state~=\"mobile\"] > %_date-picker > %_header %_year-navigation-previous": "margin-right:0px;margin-left:-12px;",
    "% > %_date-picker > %_header %_month-navigation-previous": "margin-left:25px;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header %_month-navigation-previous": "margin-left:6px;margin-right:-10px;",
    "%_rtl-direction > %_date-picker > %_header %_month-navigation-previous": "margin-right:25px;margin-left:0px;",
    "%_rtl-direction[data-state~=\"mobile\"] > %_date-picker > %_header %_month-navigation-previous": "margin-right:6px;margin-left:-10px;",
    "% > %_date-picker > %_header %_month-navigation-next": "margin-right:20px;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header %_month-navigation-next": "margin-left:-10px;margin-right:54px;",
    "%_rtl-direction > %_date-picker > %_header %_month-navigation-next": "margin-right:0px;margin-left:20px;",
    "%_rtl-direction[data-state~=\"mobile\"] > %_date-picker > %_header %_month-navigation-next": "margin-right:-10px;margin-left:54px;",
    "% > %_date-picker > %_header %_current-year,% > %_date-picker > %_header %_current-month": "text-align:center;display:inline-block;color:[txt-header];",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header %_current-year,%[data-state~=\"mobile\"] > %_date-picker > %_header %_current-month": "width:60px;",
    "% > %_date-picker > %_header %_current-year": "width:60px;cursor:pointer;",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_header %_current-year:hover": "opacity:0.75;",
    "% > %_date-picker > %_header %_current-month": "width:110px;"
  }
}
 skins['wysiwyg.viewer.skins.CalendarTextYearNavSkin'] = {
  "react": [
    [
      "div",
      "container",
      [
        "_date-picker"
      ],
      {},
      [
        "div",
        "header",
        [
          "_header"
        ],
        {},
        [
          "button",
          "previousYearNav",
          [
            "_year-navigation",
            "_year-navigation-previous"
          ],
          {},
          [
            "span",
            "previousYear",
            [],
            {}
          ]
        ],
        [
          "button",
          "previousMonthNav",
          [
            "_month-navigation",
            "_month-navigation-previous"
          ],
          {},
          [
            "svg",
            null,
            [
              "_nav-symbol"
            ],
            {
              "viewBox": "0 0 7 12.6"
            },
            [
              "path",
              null,
              [],
              {
                "d": "M7 .9L6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
              }
            ]
          ]
        ],
        [
          "div",
          "currentMonthWithYear",
          [
            "_current-month-with-year"
          ],
          {}
        ],
        [
          "button",
          "nextMonthNav",
          [
            "_month-navigation",
            "_month-navigation-next"
          ],
          {},
          [
            "svg",
            null,
            [
              "_nav-symbol"
            ],
            {
              "viewBox": "0 0 7 12.6"
            },
            [
              "path",
              null,
              [],
              {
                "d": "M7 .9L6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
              }
            ]
          ]
        ],
        [
          "button",
          "nextYearNav",
          [
            "_year-navigation",
            "_year-navigation-next"
          ],
          {},
          [
            "span",
            "nextYear",
            [],
            {}
          ]
        ]
      ],
      [
        "table",
        null,
        [],
        {},
        [
          "thead",
          null,
          [],
          {},
          [
            "tr",
            "dayNames",
            [
              "_day-names"
            ],
            {
              "role": "row"
            }
          ]
        ],
        [
          "tbody",
          "month",
          [],
          {}
        ]
      ],
      [
        "div",
        "yearOptionsWrapper",
        [
          "_year-options-wrapper"
        ],
        {}
      ]
    ]
  ],
  "exports": {
    "month": {
      "skin": "wysiwyg.viewer.skins.MonthDefaultSkin"
    }
  },
  "params": {
    "shd-calendar": "BOX_SHADOW",
    "rd-calendar": "BORDER_RADIUS",
    "bg-calendar": "BG_COLOR_ALPHA",
    "brw-calendar": "BORDER_BOTTOM_SIZE",
    "brd-calendar": "BORDER_COLOR",
    "fnt-family-day": "FONT_FAMILY",
    "txt-size-day": "TEXT_SIZE",
    "txt-day": "TEXT_COLOR",
    "bg-day-selected": "COLOR",
    "txt-day-selected": "TEXT_COLOR",
    "rd-day-selected": "BORDER_RADIUS",
    "fnt-family-header": "FONT_FAMILY",
    "txt-header": "TEXT_COLOR",
    "bg-header": "BG_COLOR_ALPHA",
    "txt-size-header": "TEXT_SIZE"
  },
  "paramsDefaults": {
    "shd-calendar": "0 0 0 rgba(0, 0, 0, 0)",
    "rd-calendar": "10px",
    "bg-calendar": "#ffffff",
    "brw-calendar": "1px",
    "brd-calendar": "#aeaeae",
    "fnt-family-day": "arial",
    "txt-size-day": "14px",
    "txt-day": "#000000",
    "bg-day-selected": "#7343d1",
    "txt-day-selected": "#ffffff",
    "rd-day-selected": "0",
    "fnt-family-header": "arial",
    "txt-header": "#ffffff",
    "bg-header": "#7343d1",
    "txt-size-header": "18px"
  },
  "css": {
    "%": "width:320px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;",
    "%[data-state~=\"mobile\"]": "height:100%;width:300px;margin:auto 10px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:end;-webkit-align-items:flex-end;align-items:flex-end;",
    "%[data-state~=\"mobile\"]:before": "content:\"\";cursor:pointer;margin-bottom:8px;background:url(\"//static.parastorage.com/services/santa-resources/resources/viewer/datePicker/mobile_x_button.svg\") no-repeat center;background-size:17px 17px;width:40px;height:40px;",
    "% > %_date-picker": "[shd-calendar]    [rd-calendar]    background-color:[bg-calendar];border:[brw-calendar] solid [brd-calendar];overflow:hidden;display:inline-block;position:relative;width:100%;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:47;",
    "%_rtl-direction > %_date-picker > %_header": "-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;flex-direction:row-reverse;",
    "%_rtl-direction > %_date-picker > %_header %_month-navigation-next > %_nav-symbol,%_rtl-direction > %_date-picker > %_header %_year-navigation-next > %_nav-symbol": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "%_rtl-direction > %_date-picker > %_header %_year-navigation-previous > %_nav-symbol,%_rtl-direction > %_date-picker > %_header %_month-navigation-previous > %_nav-symbol": "-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "% > %_date-picker %_day-names": "padding:0 20px;margin-top:15px;display:block;",
    "% > %_date-picker %_day-names:empty": "display:none;",
    "%[data-state~=\"mobile\"] > %_date-picker %_day-names": "padding:0 10px;",
    "% > %_date-picker %_day-names %_day-name": "width:40px;height:40px;[fnt-family-day]        font-size:[txt-size-day];display:inline-block;line-height:40px;text-align:center;font-weight:bold;color:[txt-day];",
    "%[data-state~=\"mobile\"] > %_date-picker %_day-names %_day-name": "font-size:14px;",
    "% > %_date-picker %_day-names %_day-name %_sr-only": "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0;",
    "% > %_date-picker > %_year-options-wrapper": "position:relative;text-align:center;max-height:280px;overflow-y:auto;margin-top:15px;margin-bottom:20px;",
    "% > %_date-picker > %_year-options-wrapper:empty": "display:none;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list": "display:inline-block;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item": "width:80px;height:40px;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item": "width:130px;",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item:not(%_selected):hover > %_year-content:before": "background-color:[bg-day-selected];opacity:0.15;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item%_selected > %_year-content": "color:[txt-day-selected];",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item%_selected > %_year-content:before": "background-color:[bg-day-selected];",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item > %_year-content": "width:78px;height:34px;[fnt-family-day]            font-size:[txt-size-day];color:[txt-day];display:block;line-height:34px;margin:3px 1px;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item > %_year-content": "font-size:14px;",
    "% > %_date-picker > %_year-options-wrapper > %_year-options-list > %_year-option-item > %_year-content:before": "[rd-day-selected]              width:78px;height:34px;position:absolute;top:auto;right:auto;bottom:auto;left:auto;content:\"\";display:block;z-index:-1;",
    "%[data-is-responsive=true]": "margin-top:22px;",
    "% > %_date-picker > %_header": "[fnt-family-header]  width:100%;height:60px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;color:[txt-header];background-color:[bg-header];border-bottom:[brw-calendar] solid [brd-calendar];",
    "% > %_date-picker > %_header > %_year-navigation,% > %_date-picker > %_header > %_month-navigation": "position:relative;display:-webkit-inline-box;display:-webkit-inline-flex;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;text-align:center;cursor:pointer;",
    "% > %_date-picker > %_header > %_year-navigation": "width:45px;height:25px;font-size:12px;word-wrap:break-word;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header > %_year-navigation": "width:40px;height:40px;",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_header > %_year-navigation:hover": "opacity:0.75;",
    "% > %_date-picker > %_header > %_month-navigation": "width:20px;height:25px;line-height:25px;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header > %_month-navigation": "width:40px;height:40px;line-height:40px;",
    "% > %_date-picker > %_header > %_month-navigation > %_nav-symbol": "height:13px;pointer-events:none;fill:[txt-header];",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header > %_month-navigation > %_nav-symbol": "height:17px;",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_header > %_month-navigation:hover > %_nav-symbol": "fill-opacity:0.75;",
    "% > %_date-picker > %_header > %_month-navigation-previous": "margin-left:10px;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header > %_month-navigation-previous": "margin-left:12px;margin-right:-10px;",
    "%_rtl-direction > %_date-picker > %_header > %_month-navigation-previous": "margin-right:10px;margin-left:0px;",
    "%_rtl-direction[data-state~=\"mobile\"] > %_date-picker > %_header > %_month-navigation-previous": "margin-right:12px;margin-left:-10px;",
    "% > %_date-picker > %_header > %_month-navigation-next": "margin-right:10px;-webkit-transform:rotate(180deg);transform:rotate(180deg);",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header > %_month-navigation-next": "margin-right:12px;margin-left:-10px;",
    "%_rtl-direction > %_date-picker > %_header > %_month-navigation-next": "margin-left:10px;margin-right:0px;",
    "%_rtl-direction[data-state~=\"mobile\"] > %_date-picker > %_header > %_month-navigation-next": "margin-left:12px;margin-right:-10px;",
    "% > %_date-picker > %_header > %_current-month-with-year": "width:140px;word-wrap:break-word;text-align:center;display:inline-block;font-size:[txt-size-header];color:[txt-header];cursor:pointer;",
    "%[data-state~=\"notMobile\"] > %_date-picker > %_header > %_current-month-with-year:hover": "opacity:0.75;",
    "%[data-state~=\"mobile\"] > %_date-picker > %_header > %_current-month-with-year": "font-size:16px;width:97px;"
  }
}
 skins['wysiwyg.viewer.skins.DayDefaultSkin'] = {
  "react": [
    [
      "button",
      "dayContent",
      [
        "_day-content"
      ],
      {}
    ]
  ],
  "params": {
    "fnt-family-day": "FONT_FAMILY",
    "txt-size-day": "TEXT_SIZE",
    "txt-day": "TEXT_COLOR",
    "txt-day-selected": "TEXT_COLOR",
    "bg-day-selected": "COLOR",
    "rd-day-selected": "BORDER_RADIUS"
  },
  "paramsDefaults": {
    "fnt-family-day": "arial",
    "txt-size-day": "14px",
    "txt-day": "#000000",
    "txt-day-selected": "#ffffff",
    "bg-day-selected": "#7343d1",
    "rd-day-selected": "0"
  },
  "css": {
    "%": "width:40px;height:40px;position:relative;display:inline-block;cursor:pointer;",
    "%_disabled": "cursor:default;",
    "%_hidden": "visibility:hidden;",
    "%_today": "font-weight:bold;",
    "% > %_day-content": "[fnt-family-day]    width:36px;height:36px;display:block;font-size:[txt-size-day];text-align:center;color:[txt-day];line-height:36px;margin:2px;",
    "%[data-state~=\"mobile\"] > %_day-content": "font-size:14px;",
    "%_today:hover > %_day-content": "color:[txt-day];",
    "%_selected:hover > %_day-content": "color:[txt-day-selected];",
    "%_disabled > %_day-content": "opacity:0.4;",
    "%_today > %_day-content": "color:[bg-day-selected];",
    "%_selected > %_day-content": "color:[txt-day-selected];",
    "% > %_day-content:before": "[rd-day-selected]      width:36px;height:36px;position:absolute;top:auto;right:auto;bottom:auto;left:auto;content:'';display:block;",
    "%_selected > %_day-content:before": "background-color:[bg-day-selected];z-index:-1;",
    "%:hover:not(%_disabled)[data-state~=\"notMobile\"] > %_day-content:before": "background-color:[bg-day-selected];",
    "%:hover:not(%_selected):not(%_disabled) > %_day-content:before": "opacity:0.15;"
  }
}
 skins['wysiwyg.viewer.skins.input.DatePickerDefaultSkin'] = {
  "react": [
    [
      "div",
      "inputLabelWrapper",
      [],
      {},
      [
        "label",
        "label",
        [],
        {}
      ],
      [
        "div",
        "inputWrapper",
        [
          "_input-wrapper"
        ],
        {},
        [
          "svg",
          "icon",
          [
            "_calendar-icon"
          ],
          {
            "viewBox": "0 0 16 15"
          },
          [
            "path",
            null,
            [],
            {
              "d": "M16 0H0v15h16zm-1 14H1V4h14zM1 3V1h14v2z"
            }
          ],
          [
            "path",
            null,
            [],
            {
              "d": "M3 6h2v2H3zm4 0h2v2H7zm4 0h2v2h-2zm0 4h2v2h-2zm-4 0h2v2H7zm-4 0h2v2H3z"
            }
          ]
        ],
        [
          "input",
          "input",
          [
            "_input"
          ],
          {
            "type": "text"
          }
        ]
      ]
    ],
    [
      "div",
      "calendar",
      [],
      {}
    ]
  ],
  "exports": {
    "calendar": {
      "skin": "wysiwyg.viewer.skins.CalendarDefaultSkin"
    }
  },
  "params": {
    "rd": "BORDER_RADIUS",
    "brw": "BORDER_SIZES",
    "shd": "BOX_SHADOW",
    "bg": "BG_COLOR_ALPHA",
    "brd": "BORDER_COLOR_ALPHA",
    "brwe": "BORDER_SIZES",
    "bge": "BG_COLOR_ALPHA",
    "brde": "BORDER_COLOR_ALPHA",
    "brwd": "BORDER_SIZES",
    "bgd": "BG_COLOR_ALPHA",
    "brdd": "BORDER_COLOR_ALPHA",
    "brwf": "BORDER_SIZES",
    "bgf": "BG_COLOR_ALPHA",
    "brdf": "BORDER_COLOR_ALPHA",
    "brwh": "BORDER_SIZES",
    "bgh": "BG_COLOR_ALPHA",
    "brdh": "BORDER_COLOR_ALPHA",
    "icn-color": "COLOR_ALPHA",
    "fnt": "FONT",
    "txt": "TEXT_COLOR",
    "txtd": "TEXT_COLOR",
    "txt-placeholder": "TEXT_COLOR",
    "fntlbl": "FONT",
    "txtlbl": "TEXT_COLOR",
    "txtlblrq": "COLOR_ALPHA"
  },
  "paramsDefaults": {
    "rd": "0",
    "brw": "1px",
    "shd": "0 0 0 rgba(0, 0, 0, 0)",
    "bg": "#ffffff",
    "brd": "#cacaca",
    "brwe": "1px",
    "bge": "#ffffff",
    "brde": "#f60419",
    "brwd": "1px",
    "bgd": "#ffffff",
    "brdd": "#CCCCCC",
    "brwf": "1px",
    "bgf": "#ffffff",
    "brdf": "#7343d1",
    "brwh": "1px",
    "bgh": "#ffffff",
    "brdh": "#cacaca",
    "icn-color": "#cacaca",
    "fnt": "font_8",
    "txt": "#000000",
    "txtd": "#CCCCCC",
    "txt-placeholder": "#A9A9A9",
    "fntlbl": "font_8",
    "txtlbl": "color_15",
    "txtlblrq": "transparent"
  },
  "css": {
    "% > %inputLabelWrapper": "overflow:hidden;",
    "% > %inputLabelWrapper > %_input-wrapper": "[rd]    [brw]    [shd]    width:100%;height:100%;position:relative;box-sizing:border-box;background-color:[bg];border-style:solid;border-color:[brd];cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-flex:1;-webkit-flex:1;flex:1;",
    "%[data-state~=\"mobile\"] > %inputLabelWrapper > %_input-wrapper": "-webkit-tap-highlight-color:rgba(0, 0, 0, 0);",
    "%_right-direction > %inputLabelWrapper > %_input-wrapper": "text-align:right;",
    "%_invalid%_with-validation-indication > %inputLabelWrapper > %_input-wrapper": "[brwe]      background-color:[bge];border-style:solid;border-color:[brde];",
    "%[data-error=\"true\"] > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"error\"] > %inputLabelWrapper > %_input-wrapper": "[brwe]      background-color:[bge];border-style:solid;border-color:[brde];",
    "%_read-only > %inputLabelWrapper > %_input-wrapper,%[data-disabled=\"true\"] > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"disabled\"] > %inputLabelWrapper > %_input-wrapper": "cursor:default;",
    "%[data-disabled=\"true\"] > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"disabled\"] > %inputLabelWrapper > %_input-wrapper": "[brwd]      background-color:[bgd];border-style:solid;border-color:[brdd];",
    "%_focused > %inputLabelWrapper > %_input-wrapper,%:focus > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"focus\"] > %inputLabelWrapper > %_input-wrapper": "[brwf]      background-color:[bgf];border-style:solid;border-color:[brdf];",
    "%:hover:not(%_focused):not(%_read-only):not([data-error=\"true\"]):not([data-disabled=\"true\"]):not([data-state~=\"mobile\"]) > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"hover\"]:not(%_focused):not(%_read-only):not([data-error=\"true\"]):not([data-disabled=\"true\"]):not([data-state~=\"mobile\"]) > %inputLabelWrapper > %_input-wrapper": "[brwh]      background-color:[bgh];border-style:solid;border-color:[brdh];",
    "% > %inputLabelWrapper > %_input-wrapper > %_calendar-icon": "width:16px;height:16px;margin-top:calc(-16px / 2);fill:[icn-color];pointer-events:none;",
    "%_left-direction > %inputLabelWrapper > %_input-wrapper > %_calendar-icon,%_center-direction > %inputLabelWrapper > %_input-wrapper > %_calendar-icon": "position:absolute;top:50%;right:20px;bottom:auto;left:auto;",
    "%_right-direction > %inputLabelWrapper > %_input-wrapper > %_calendar-icon": "position:absolute;top:50%;right:auto;bottom:auto;left:20px;",
    "% > %inputLabelWrapper > %_input-wrapper > %_input": "[rd]      [fnt]      width:calc(100% - 16px - 40px);height:100%;background-color:transparent;color:[txt];pointer-events:none;text-overflow:ellipsis;border:transparent;display:inline-block;",
    "%_read-only > %inputLabelWrapper > %_input-wrapper > %_input": "pointer-events:auto;",
    "%_left-direction > %inputLabelWrapper > %_input-wrapper > %_input": "text-align:left;",
    "%_center-direction > %inputLabelWrapper > %_input-wrapper > %_input": "text-align:center;",
    "%_right-direction > %inputLabelWrapper > %_input-wrapper > %_input": "text-align:right;",
    "%[data-disabled=\"true\"] > %inputLabelWrapper > %_input-wrapper > %_input,%[data-preview~=\"disabled\"] > %inputLabelWrapper > %_input-wrapper > %_input": "-webkit-text-fill-color:[txtd];color:[txtd];",
    "% > %inputLabelWrapper > %_input-wrapper > %_input::-webkit-input-placeholder": "color:[txt-placeholder];",
    "% > %inputLabelWrapper > %_input-wrapper > %_input::-ms-input-placeholder": "color:[txt-placeholder];",
    "% > %inputLabelWrapper > %_input-wrapper > %_input::placeholder": "color:[txt-placeholder];",
    "% > %calendar": "position:absolute;",
    "%_left-direction > %calendar": "left:0;",
    "%_center-direction > %calendar": "left:calc(50% - 320px / 2);",
    "%_right-direction > %calendar": "right:0;",
    "%label": "[fntlbl]  color:[txtlbl];word-break:break-word;display:inline-block;line-height:1;",
    "%_required %label::after": "content:\" *\";color:[txtlblrq];",
    "%inputLabelWrapper": "margin-bottom:22px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;height:100%;",
    "%[data-is-responsive=true] %inputLabelWrapper": "margin-bottom:0;"
  }
}
 skins['wysiwyg.viewer.skins.input.DatePickerTextBetweenNavSkin'] = {
  "react": [
    [
      "div",
      "inputLabelWrapper",
      [],
      {},
      [
        "label",
        "label",
        [],
        {}
      ],
      [
        "div",
        "inputWrapper",
        [
          "_input-wrapper"
        ],
        {},
        [
          "svg",
          "icon",
          [
            "_calendar-icon"
          ],
          {
            "viewBox": "0 0 16 15"
          },
          [
            "path",
            null,
            [],
            {
              "d": "M16 0H0v15h16zm-1 14H1V4h14zM1 3V1h14v2z"
            }
          ],
          [
            "path",
            null,
            [],
            {
              "d": "M3 6h2v2H3zm4 0h2v2H7zm4 0h2v2h-2zm0 4h2v2h-2zm-4 0h2v2H7zm-4 0h2v2H3z"
            }
          ]
        ],
        [
          "input",
          "input",
          [
            "_input"
          ],
          {
            "type": "text"
          }
        ]
      ]
    ],
    [
      "div",
      "calendar",
      [],
      {}
    ]
  ],
  "exports": {
    "calendar": {
      "skin": "wysiwyg.viewer.skins.CalendarTextBetweenNavSkin"
    }
  },
  "params": {
    "rd": "BORDER_RADIUS",
    "brw": "BORDER_SIZES",
    "shd": "BOX_SHADOW",
    "bg": "BG_COLOR_ALPHA",
    "brd": "BORDER_COLOR_ALPHA",
    "brwe": "BORDER_SIZES",
    "bge": "BG_COLOR_ALPHA",
    "brde": "BORDER_COLOR_ALPHA",
    "brwd": "BORDER_SIZES",
    "bgd": "BG_COLOR_ALPHA",
    "brdd": "BORDER_COLOR_ALPHA",
    "brwf": "BORDER_SIZES",
    "bgf": "BG_COLOR_ALPHA",
    "brdf": "BORDER_COLOR_ALPHA",
    "brwh": "BORDER_SIZES",
    "bgh": "BG_COLOR_ALPHA",
    "brdh": "BORDER_COLOR_ALPHA",
    "icn-color": "COLOR_ALPHA",
    "fnt": "FONT",
    "txt": "TEXT_COLOR",
    "txtd": "TEXT_COLOR",
    "txt-placeholder": "TEXT_COLOR",
    "fntlbl": "FONT",
    "txtlbl": "TEXT_COLOR",
    "txtlblrq": "COLOR_ALPHA"
  },
  "paramsDefaults": {
    "rd": "0",
    "brw": "1px",
    "shd": "0 0 0 rgba(0, 0, 0, 0)",
    "bg": "#ffffff",
    "brd": "#cacaca",
    "brwe": "1px",
    "bge": "#ffffff",
    "brde": "#f60419",
    "brwd": "1px",
    "bgd": "#ffffff",
    "brdd": "#CCCCCC",
    "brwf": "1px",
    "bgf": "#ffffff",
    "brdf": "#7343d1",
    "brwh": "1px",
    "bgh": "#ffffff",
    "brdh": "#cacaca",
    "icn-color": "#cacaca",
    "fnt": "font_8",
    "txt": "#000000",
    "txtd": "#CCCCCC",
    "txt-placeholder": "#A9A9A9",
    "fntlbl": "font_8",
    "txtlbl": "color_15",
    "txtlblrq": "transparent"
  },
  "css": {
    "% > %inputLabelWrapper": "overflow:hidden;",
    "% > %inputLabelWrapper > %_input-wrapper": "[rd]    [brw]    [shd]    width:100%;height:100%;position:relative;box-sizing:border-box;background-color:[bg];border-style:solid;border-color:[brd];cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-flex:1;-webkit-flex:1;flex:1;",
    "%[data-state~=\"mobile\"] > %inputLabelWrapper > %_input-wrapper": "-webkit-tap-highlight-color:rgba(0, 0, 0, 0);",
    "%_right-direction > %inputLabelWrapper > %_input-wrapper": "text-align:right;",
    "%_invalid%_with-validation-indication > %inputLabelWrapper > %_input-wrapper": "[brwe]      background-color:[bge];border-style:solid;border-color:[brde];",
    "%[data-error=\"true\"] > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"error\"] > %inputLabelWrapper > %_input-wrapper": "[brwe]      background-color:[bge];border-style:solid;border-color:[brde];",
    "%_read-only > %inputLabelWrapper > %_input-wrapper,%[data-disabled=\"true\"] > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"disabled\"] > %inputLabelWrapper > %_input-wrapper": "cursor:default;",
    "%[data-disabled=\"true\"] > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"disabled\"] > %inputLabelWrapper > %_input-wrapper": "[brwd]      background-color:[bgd];border-style:solid;border-color:[brdd];",
    "%_focused > %inputLabelWrapper > %_input-wrapper,%:focus > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"focus\"] > %inputLabelWrapper > %_input-wrapper": "[brwf]      background-color:[bgf];border-style:solid;border-color:[brdf];",
    "%:hover:not(%_focused):not(%_read-only):not([data-error=\"true\"]):not([data-disabled=\"true\"]):not([data-state~=\"mobile\"]) > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"hover\"]:not(%_focused):not(%_read-only):not([data-error=\"true\"]):not([data-disabled=\"true\"]):not([data-state~=\"mobile\"]) > %inputLabelWrapper > %_input-wrapper": "[brwh]      background-color:[bgh];border-style:solid;border-color:[brdh];",
    "% > %inputLabelWrapper > %_input-wrapper > %_calendar-icon": "width:16px;height:16px;margin-top:calc(-16px / 2);fill:[icn-color];pointer-events:none;",
    "%_left-direction > %inputLabelWrapper > %_input-wrapper > %_calendar-icon,%_center-direction > %inputLabelWrapper > %_input-wrapper > %_calendar-icon": "position:absolute;top:50%;right:20px;bottom:auto;left:auto;",
    "%_right-direction > %inputLabelWrapper > %_input-wrapper > %_calendar-icon": "position:absolute;top:50%;right:auto;bottom:auto;left:20px;",
    "% > %inputLabelWrapper > %_input-wrapper > %_input": "[rd]      [fnt]      width:calc(100% - 16px - 40px);height:100%;background-color:transparent;color:[txt];pointer-events:none;text-overflow:ellipsis;border:transparent;display:inline-block;",
    "%_read-only > %inputLabelWrapper > %_input-wrapper > %_input": "pointer-events:auto;",
    "%_left-direction > %inputLabelWrapper > %_input-wrapper > %_input": "text-align:left;",
    "%_center-direction > %inputLabelWrapper > %_input-wrapper > %_input": "text-align:center;",
    "%_right-direction > %inputLabelWrapper > %_input-wrapper > %_input": "text-align:right;",
    "%[data-disabled=\"true\"] > %inputLabelWrapper > %_input-wrapper > %_input,%[data-preview~=\"disabled\"] > %inputLabelWrapper > %_input-wrapper > %_input": "-webkit-text-fill-color:[txtd];color:[txtd];",
    "% > %inputLabelWrapper > %_input-wrapper > %_input::-webkit-input-placeholder": "color:[txt-placeholder];",
    "% > %inputLabelWrapper > %_input-wrapper > %_input::-ms-input-placeholder": "color:[txt-placeholder];",
    "% > %inputLabelWrapper > %_input-wrapper > %_input::placeholder": "color:[txt-placeholder];",
    "% > %calendar": "position:absolute;",
    "%_left-direction > %calendar": "left:0;",
    "%_center-direction > %calendar": "left:calc(50% - 320px / 2);",
    "%_right-direction > %calendar": "right:0;",
    "%label": "[fntlbl]  color:[txtlbl];word-break:break-word;display:inline-block;line-height:1;",
    "%_required %label::after": "content:\" *\";color:[txtlblrq];",
    "%inputLabelWrapper": "margin-bottom:22px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;height:100%;",
    "%[data-is-responsive=true] %inputLabelWrapper": "margin-bottom:0;"
  }
}
 skins['wysiwyg.viewer.skins.input.DatePickerTextYearNavSkin'] = {
  "react": [
    [
      "div",
      "inputLabelWrapper",
      [],
      {},
      [
        "label",
        "label",
        [],
        {}
      ],
      [
        "div",
        "inputWrapper",
        [
          "_input-wrapper"
        ],
        {},
        [
          "svg",
          "icon",
          [
            "_calendar-icon"
          ],
          {
            "viewBox": "0 0 16 15"
          },
          [
            "path",
            null,
            [],
            {
              "d": "M16 0H0v15h16zm-1 14H1V4h14zM1 3V1h14v2z"
            }
          ],
          [
            "path",
            null,
            [],
            {
              "d": "M3 6h2v2H3zm4 0h2v2H7zm4 0h2v2h-2zm0 4h2v2h-2zm-4 0h2v2H7zm-4 0h2v2H3z"
            }
          ]
        ],
        [
          "input",
          "input",
          [
            "_input"
          ],
          {
            "type": "text"
          }
        ]
      ]
    ],
    [
      "div",
      "calendar",
      [],
      {}
    ]
  ],
  "exports": {
    "calendar": {
      "skin": "wysiwyg.viewer.skins.CalendarTextYearNavSkin"
    }
  },
  "params": {
    "rd": "BORDER_RADIUS",
    "brw": "BORDER_SIZES",
    "shd": "BOX_SHADOW",
    "bg": "BG_COLOR_ALPHA",
    "brd": "BORDER_COLOR_ALPHA",
    "brwe": "BORDER_SIZES",
    "bge": "BG_COLOR_ALPHA",
    "brde": "BORDER_COLOR_ALPHA",
    "brwd": "BORDER_SIZES",
    "bgd": "BG_COLOR_ALPHA",
    "brdd": "BORDER_COLOR_ALPHA",
    "brwf": "BORDER_SIZES",
    "bgf": "BG_COLOR_ALPHA",
    "brdf": "BORDER_COLOR_ALPHA",
    "brwh": "BORDER_SIZES",
    "bgh": "BG_COLOR_ALPHA",
    "brdh": "BORDER_COLOR_ALPHA",
    "icn-color": "COLOR_ALPHA",
    "fnt": "FONT",
    "txt": "TEXT_COLOR",
    "txtd": "TEXT_COLOR",
    "txt-placeholder": "TEXT_COLOR",
    "fntlbl": "FONT",
    "txtlbl": "TEXT_COLOR",
    "txtlblrq": "COLOR_ALPHA"
  },
  "paramsDefaults": {
    "rd": "0",
    "brw": "1px",
    "shd": "0 0 0 rgba(0, 0, 0, 0)",
    "bg": "#ffffff",
    "brd": "#cacaca",
    "brwe": "1px",
    "bge": "#ffffff",
    "brde": "#f60419",
    "brwd": "1px",
    "bgd": "#ffffff",
    "brdd": "#CCCCCC",
    "brwf": "1px",
    "bgf": "#ffffff",
    "brdf": "#7343d1",
    "brwh": "1px",
    "bgh": "#ffffff",
    "brdh": "#cacaca",
    "icn-color": "#cacaca",
    "fnt": "font_8",
    "txt": "#000000",
    "txtd": "#CCCCCC",
    "txt-placeholder": "#A9A9A9",
    "fntlbl": "font_8",
    "txtlbl": "color_15",
    "txtlblrq": "transparent"
  },
  "css": {
    "% > %inputLabelWrapper": "overflow:hidden;",
    "% > %inputLabelWrapper > %_input-wrapper": "[rd]    [brw]    [shd]    width:100%;height:100%;position:relative;box-sizing:border-box;background-color:[bg];border-style:solid;border-color:[brd];cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-flex:1;-webkit-flex:1;flex:1;",
    "%[data-state~=\"mobile\"] > %inputLabelWrapper > %_input-wrapper": "-webkit-tap-highlight-color:rgba(0, 0, 0, 0);",
    "%_right-direction > %inputLabelWrapper > %_input-wrapper": "text-align:right;",
    "%_invalid%_with-validation-indication > %inputLabelWrapper > %_input-wrapper": "[brwe]      background-color:[bge];border-style:solid;border-color:[brde];",
    "%[data-error=\"true\"] > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"error\"] > %inputLabelWrapper > %_input-wrapper": "[brwe]      background-color:[bge];border-style:solid;border-color:[brde];",
    "%_read-only > %inputLabelWrapper > %_input-wrapper,%[data-disabled=\"true\"] > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"disabled\"] > %inputLabelWrapper > %_input-wrapper": "cursor:default;",
    "%[data-disabled=\"true\"] > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"disabled\"] > %inputLabelWrapper > %_input-wrapper": "[brwd]      background-color:[bgd];border-style:solid;border-color:[brdd];",
    "%_focused > %inputLabelWrapper > %_input-wrapper,%:focus > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"focus\"] > %inputLabelWrapper > %_input-wrapper": "[brwf]      background-color:[bgf];border-style:solid;border-color:[brdf];",
    "%:hover:not(%_focused):not(%_read-only):not([data-error=\"true\"]):not([data-disabled=\"true\"]):not([data-state~=\"mobile\"]) > %inputLabelWrapper > %_input-wrapper,%[data-preview~=\"hover\"]:not(%_focused):not(%_read-only):not([data-error=\"true\"]):not([data-disabled=\"true\"]):not([data-state~=\"mobile\"]) > %inputLabelWrapper > %_input-wrapper": "[brwh]      background-color:[bgh];border-style:solid;border-color:[brdh];",
    "% > %inputLabelWrapper > %_input-wrapper > %_calendar-icon": "width:16px;height:16px;margin-top:calc(-16px / 2);fill:[icn-color];pointer-events:none;",
    "%_left-direction > %inputLabelWrapper > %_input-wrapper > %_calendar-icon,%_center-direction > %inputLabelWrapper > %_input-wrapper > %_calendar-icon": "position:absolute;top:50%;right:20px;bottom:auto;left:auto;",
    "%_right-direction > %inputLabelWrapper > %_input-wrapper > %_calendar-icon": "position:absolute;top:50%;right:auto;bottom:auto;left:20px;",
    "% > %inputLabelWrapper > %_input-wrapper > %_input": "[rd]      [fnt]      width:calc(100% - 16px - 40px);height:100%;background-color:transparent;color:[txt];pointer-events:none;text-overflow:ellipsis;border:transparent;display:inline-block;",
    "%_read-only > %inputLabelWrapper > %_input-wrapper > %_input": "pointer-events:auto;",
    "%_left-direction > %inputLabelWrapper > %_input-wrapper > %_input": "text-align:left;",
    "%_center-direction > %inputLabelWrapper > %_input-wrapper > %_input": "text-align:center;",
    "%_right-direction > %inputLabelWrapper > %_input-wrapper > %_input": "text-align:right;",
    "%[data-disabled=\"true\"] > %inputLabelWrapper > %_input-wrapper > %_input,%[data-preview~=\"disabled\"] > %inputLabelWrapper > %_input-wrapper > %_input": "-webkit-text-fill-color:[txtd];color:[txtd];",
    "% > %inputLabelWrapper > %_input-wrapper > %_input::-webkit-input-placeholder": "color:[txt-placeholder];",
    "% > %inputLabelWrapper > %_input-wrapper > %_input::-ms-input-placeholder": "color:[txt-placeholder];",
    "% > %inputLabelWrapper > %_input-wrapper > %_input::placeholder": "color:[txt-placeholder];",
    "% > %calendar": "position:absolute;",
    "%_left-direction > %calendar": "left:0;",
    "%_center-direction > %calendar": "left:calc(50% - 320px / 2);",
    "%_right-direction > %calendar": "right:0;",
    "%label": "[fntlbl]  color:[txtlbl];word-break:break-word;display:inline-block;line-height:1;",
    "%_required %label::after": "content:\" *\";color:[txtlblrq];",
    "%inputLabelWrapper": "margin-bottom:22px;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;height:100%;",
    "%[data-is-responsive=true] %inputLabelWrapper": "margin-bottom:0;"
  }
}
 skins['wysiwyg.viewer.skins.MonthDefaultSkin'] = {
  "react": [],
  "exports": {
    "day": {
      "skin": "wysiwyg.viewer.skins.DayDefaultSkin"
    }
  },
  "css": {
    "%": "padding:0 20px;margin-bottom:20px;display:block;",
    "%:empty": "display:none;",
    "%[data-state~=\"mobile\"]": "width:300px;padding:0 10px;"
  }
}

        return skins;
    }));